import { useStaticQuery, graphql } from "gatsby"

export default () => {
  const data = useStaticQuery(graphql`
    query FacilityContextQuery {
      site {
        siteMetadata {
          siteUrl
          logoImgId
          logoIconImageId
          logoTextImageId
          logoTextImageHorizontalId
        }
      }
      sanityFacility(_id: { eq: "084b80fe-4b53-45f2-8926-aacca2993ca1" }) {
        facilityObj {
          facilityName
          facilityInfo {
            streetAddress
            city
            state
            zip
            phone
            facebookUrl
            twitterUrl
            email
            billPayUrl
            covidStatusUrl
            dptHealthCovidGuidelinesUrl
            returnToWorkGuidelines {
              asset {
                url
              }
            }
            covidLinks {
              _key
              description
              url
            }
            covidDownloads {
              _key
              description
              file {
                asset {
                  url
                }
              }
            }
            facilityGroundsImage {
              asset {
                source {
                  id
                }
              }
            }
          }
          services {
            _key
            title
          }
          testimonials {
            _key
            content
            name
          }
          siteContent {
            initParagraphTitle
            initParagraphText
            initParagraphGallery {
              image {
                asset {
                  source {
                    id
                  }
                }
              }
              altText
            }
            tagline
            googleMapsEmbed {
              googleMapsEmbedCode
            }
          }
          video {
            youtubeUrl
          }
          gallery {
            image {
              asset {
                source {
                  id
                }
              }
            }
            altText
          }
          videoGallery {
            youtubeUrl
          }
        }
      }
    }
  `)

  return data
}
